import { EventEmitter, Inject, Injectable } from '@angular/core';
import { AlertComponent } from './alert/alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DailogService {
  alertType:string;
  alertMessage:string;
  private lastDialogRef: MatDialogRef<any> | null = null;
  private lastTempType: string = '';
  private alertTimeout: any;


  constructor(public dialog: MatDialog) {
    
  }

  showAlert(type: string, message: string) {
    this.lastTempType = type;
     const dialogRef = this.dialog.open(AlertComponent, {
        data: { type: type, message: message },
        width: '400px',
        panelClass: 'top-alert-dialog',
        position: {
          top: '250px',
          left: '35%',
        },
        disableClose: true,
      });
      this.lastDialogRef = dialogRef;
}

confirm(type: string, message: string){
  this.lastTempType = type;
  const dialogRef = this.dialog.open(AlertComponent, {
    data: { type: type, message: message },
    width: '400px',
    panelClass: 'top-alert-dialog',
    position: {
      top: '250px',
      left: '35%',
    },
    disableClose: true,
  });

  // Return the afterClosed observable directly
  return dialogRef.afterClosed().pipe(
    map((response) => {
      return response; 
    })
  );
}

closeAlert() {
  if (this.alertTimeout) {
    clearTimeout(this.alertTimeout); // clear old timer
  }

  this.alertTimeout = setTimeout(() => {
    const type = this.lastTempType;

    if (
      type === 'alert-warning' ||
      type === 'alert-success' ||
      type === 'alert-danger'
    ) {
      this.lastDialogRef?.close();
    }
  }, 6000);
}



// closeAlert() {
//   if (this.alertTimeout) {
//     clearTimeout(this.alertTimeout); // clear previous timeout
//   }

//   this.alertTimeout = setTimeout(() => {
//     const type = this.lastDialogRef?.componentInstance?.temp_type;

//     if (
//       type === 'alert-warning' ||
//       type === 'alert-success' ||
//       type === 'alert-danger'
//     ) {
//       console.log(type);
//       this.lastDialogRef?.close(); //  Close only that one dialog
//     }
//   }, 6000);
// }



// closeAlert() {
//     setTimeout(() => {
//       if (
//         this.temp_type == 'alert-warning' ||
//         this.temp_type === 'alert-success' ||
//         this.temp_type === 'alert-danger'
//       ) {
//         console.log(this.temp_type);
//         this.dialog.closeAll();
//       }
//     }, 6000);
//   }
}
